import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import {
  FaCalendarAlt, FaUserFriends, FaBuilding, FaCogs, FaChartBar,
  FaEnvelope, FaWhatsapp, FaVideo, FaAd, FaClipboardList
} from 'react-icons/fa';
import { useWhatsAppMessage } from '../../context/WhatsAppMessageContext';

const Sidebar = () => {
  const location = useLocation();
  const { totalUnreadCount } = useWhatsAppMessage();
  const isOnWhatsAppPage = location.pathname.startsWith('/whatsapp');

  const menuItems = [
    { label: 'Dashboard', icon: <FaChartBar />, path: '/dashboard' },
    { label: 'Events', icon: <FaCalendarAlt />, path: '/events' },
    { label: 'Leads', icon: <FaUserFriends />, path: '/leads' },
    { label: 'Accounts', icon: <FaBuilding />, path: '/accounts' },
    { label: 'Automation', icon: <FaCogs />, path: '/automation' },
    { label: 'Growth', icon: <FaChartBar />, path: '/growth' },
  ];

  const integrations = [
    { label: 'Email', icon: <FaEnvelope />, path: '/email' },
    { label: 'WhatsApp', icon: <FaWhatsapp />, path: '/whatsapp' },
    { label: 'Video Conf.', icon: <FaVideo />, path: '/video-conf' },
    { label: 'Ads Compose', icon: <FaAd />, path: '/ads-compose' },
    { label: 'Calendar', icon: <FaClipboardList />, path: '/calendar' },
    { label: 'Templates', icon: <FaClipboardList />, path: '/templates' },
  ];

  return (
    <div
      style={{
        width: '220px',
        background: 'linear-gradient(to right, #E4E5EB 80%, #ffffff 100%)',
        minHeight: '100vh',
        padding: '20px',
        marginLeft: '10px',
        borderTopLeftRadius: '12px',
        borderBottomLeftRadius: '12px',
        boxShadow: '2px 0 5px rgba(0,0,0,0.05)'
      }}
    >
      <ListGroup style={{ border: 'none' }}>
        {menuItems.map((item, idx) => (
          <ListGroup.Item
            key={idx}
            as={NavLink}
            to={item.path}
            className="sidebar-item d-flex align-items-center"
          >
            <span className="me-2">{item.icon}</span> {item.label}
          </ListGroup.Item>
        ))}
      </ListGroup>

      {/* Darker Divider */}
      <hr style={{ margin: '20px 0', borderTop: '2px solid #b0b0b0' }} />

      {/* Subheading for Integrations */}
      <div className="d-flex align-items-center mb-2 text-muted" style={{ fontSize: '0.9rem', fontWeight: 600 }}>
        <FaCogs className="me-2" /> Integrations
      </div>

      <ListGroup style={{ border: 'none' }}>
        {integrations.map((item, idx) => (
          <ListGroup.Item
            key={idx}
            as={NavLink}
            to={item.path}
            className="sidebar-item d-flex align-items-center"
            style={{ position: 'relative' }}
          >
            <span className="me-2">{item.icon}</span> {item.label}
            {item.path === '/whatsapp' && !isOnWhatsAppPage && totalUnreadCount > 0 && (
              <span
                style={{
                  position: 'absolute',
                  right: '12px',
                  backgroundColor: '#B2400B',
                  color: 'white',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '0.75rem',
                  fontWeight: 'bold',
                }}
              >
                {totalUnreadCount > 99 ? '99+' : totalUnreadCount}
              </span>
            )}
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default Sidebar;
